module.exports = __webpack_public_path__ + "static/media/puzzle-24-bg.86742fb6.svg";